import React, { useContext, useState } from 'react'
import { Box, Typography, Popover, Button } from '@mui/material'
import { makeStyles } from "@mui/styles";
import { AuctionContext } from '../context/auctionContext'
import { UserContext } from '../context/userContext'
import ListLotItemOffer from './ListLotItemOffer';
import APP_ENVIRONMENT from '../environment/environment'
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.primary.main,
    borderWidth: 3.5,
    borderStyle: 'solid',
    borderColor: theme.palette.primary.lightBackground,
    borderRadius: 0,
    maxWidth: 300,
    gap: 4
  },
  title: {
    padding: 1,
    fontSize: 18,
    textAlign: 'center',
    color: theme.palette.lightgray.main,
  },
  paraph: {
    fontSize: 12,
    textAlign: 'center',
    color: theme.palette.lightgray.main,
    fontFamily: 'ITC Officina Sans Std, Book',
  },
  awardPopover: {
    backgroundColor: 'transparent',
  },
  awardsPaper: {
    backgroundColor: 'transparent',
  },
  navBarTextBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  navBarText: {
    fontSize: 20,
    color: "#ffff"
  },

}))

const LotOffers = React.forwardRef((props, ref) => {
  const classes = useStyles()
  const user = useContext(UserContext)
  const [anchorEl, setAnchorEl] = useState(null)
  const { auction } = useContext(AuctionContext)
  const [lotInfo, setLotInfo] = useState([])
  const { token, externalId } = user?.userData
  const { id, areaId } = auction
  const URL = APP_ENVIRONMENT.BASE_URL_WEBSITE

  const getInfo = async () => {
    try {
      const response = await axios.get(`${URL}/api/v1/guarantees/getOffersByAuctionId?areaId=${areaId}&userId=${externalId}&auctionId=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      setLotInfo(response.data.offers)
    } catch (error) {
      console.log(error)
    }
  }
  const toggleAwards = (event) => {
    setAnchorEl(event.currentTarget)
  }
  return <Box>
    <Box className={classes.navBarTextBox} onClick={toggleAwards}>
      <Typography variant="body2" className={classes.navBarText}>
        Mis Ofertas
      </Typography>
    </Box>
    <Popover
      className={classes.awardPopover}
      classes={{ paper: classes.awardsPaper }}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={() => setAnchorEl(null)}
      elevation={0}
      PaperProps={{ square: true }}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
    >
      <Box
        p={1}
        display="flex"
        flexDirection="column"
        className={classes.container}
        ref={ref}
      >
        <Box p={0.6} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            onClick={getInfo}
            sx={{
              backgroundColor: '#ffffffff',
              color: 'white',
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: 'bold',
              borderRadius: '4px',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: '#bdbdbdff',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
              },
              '&:active': {
                transform: 'translateY(0px)',
              }
            }}
          >
            Consultar mis ofertas
          </Button>
        </Box>
        <Box p={0.6} sx={{ display: 'flex', flexDirection: 'column', gap: 1, maxHeight: 250, overflow: "auto" }}>
          {lotInfo ?
            lotInfo.map((lot, idx) => (
              <ListLotItemOffer
                key={idx}
                areaId={auction.areaId}
                lotInfo={lot}
                auction={auction}
                disableTaxLabel
              />
            ))
            :
            null
          }
        </Box>

      </Box>
    </Popover>
  </Box>


})
export default LotOffers
